import { environment } from "src/environments/environment.dev";
import AppConfig from '../../assets/app-env-config.json';

import { GlobalBase } from "./global-base";

import config from '../../assets/app-env-config.json';
import Config from "chart.js/dist/core/core.config";

export class GlobalProperties  { 

 
    //************************************One Login All User********************************** */

    static _userGUID='3fa85f64-5717-4562-b3fc-2c963f66afa6'

    static _oneLoginUserName='UTL0944';
    static _oneLoginPassword='Utl@0944';
//  static _managerUserName = 'Indrajeet';
 //  static _managerUserName = 'manager';
    

    
   // static _compnayCode = 'BaseDBConnection';
  
   

//******************Start***********************Development Login On Local ********************************************** */


//   static _apiUrlSap ='https://192.168.2.126:50000/b1s/v1/';//for stag publish
//  static _gateWayAPIUrl ='https://192.168.2.126:60000/';
// static _companyDb='INT_WMSDEVSAPHANA'; 
//  static _dbInstance= "NDB@192.168.2.26:30013";
//  static _compnayCode='SAPHANADBConnection';
//   static _folderName='SAPHANADBConnection';

//  static _companyCodeSecuirtyService='SAPHANADBConnection';
//  static _gatewayUserId='UTL0792';
//   static _gatewayUserPassword='Utl@0792';
//  static _managerUserName = 'UTL0792'

static _apiUrlSap=config._apiUrlSap;
static _gateWayAPIUrl=config._gateWayAPIUrl;
static _companyDb=config._companyDb;
static _dbInstance=config._dbInstance;
static _compnayCode=config._compnayCode;
 static _folderName=config._folderName;
 static _companyCodeSecuirtyService=config._companyCodeSecuirtyService;
 static _gatewayUserId=config._gatewayUserId;
 static _gatewayUserPassword=config._gatewayUserPassword;
 static _managerUserName=config._managerUserName;







//*****************End********************Development Login On Local *****************************************************





//**********************Start*********************B1 online Demo For Sales Team*************************************************** */

//  static _apiUrlSap ='https://analytics20.ubshanacloud.in:50000/b1s/v1/';//for stag publish
//  static _gateWayAPIUrl ='https://analytics20.ubshanacloud.in:60000/';
// static _companyDb='SBODEMOIN1'; 
//  static _dbInstance= "NDB@su020h:30015";
//  static _compnayCode='SBODEMOIN1';
//   static _folderName='SBODEMOIN1';

//  static _companyCodeSecuirtyService='SBODEMOIN1';
//  static _gatewayUserId='ubshanacloud\\pr.user1';
//   static _gatewayUserPassword='N!ce2u7%';
//  //static _managerUserName = 'UTL0792'


//*******************End************************B1 online Demo For Sales Team*************************************************** */

 



//*****************Start************************Prompt Login Live********************************************** */
//   static _apiUrlSap ='https://sap.promptsteel.com:50000/b1s/v1/';
//  static _gateWayAPIUrl ='https://sap.promptsteel.com:60000/'; 
// //static _companyDb='TEST_PROMPT';
// static _companyDb='PROMPT';
//  static _dbInstance= "NDB@192.168.1.9";
//  static _compnayCode='PROMPT';
//   static _folderName='PROMPT';

//  static _companyCodeSecuirtyService='PROMPT';
//  static _gatewayUserId='manager';
//   static _gatewayUserPassword='S@pB11982';
//   static _managerUserName = 'UTL0792'


//*****************End************************Prompt Login Live********************************************** */



 // ********************Start*********************SSO Login**************************************************
//  static _apiUrlSap = 'https://ubsdemo.ubshanacloud.in:50000/b1s/v2/';
//    static _gateWayAPIUrl = 'https://ubsdemo.ubshanacloud.in:60000/';
//     static _companyDb = 'SBODEMOIN';
//     static  _dbInstance= "NDB@10.0.2.22:30013";
//     static _compnayCode='SBODEMOIN';
//     static _folderName='SBODEMOIN';
//      static _companyCodeSecuirtyService = 'SBODEMOIN';
//     static _gatewayUserId='b1api';
//     static _gatewayUserPassword='Unp@123456';

    //Properties Declarations

// ********************End*********************SSO Login**************************************************


    

     public static get getApiUrlSap(): string {
        return this._apiUrlSap;
    };

    public static get getcompnayCode(): string {
        return this._compnayCode;
    };

    public static get getManagerUserName(): string {
        return this._managerUserName;
    };

    public static get getcompanyCodeSecuirtyService(): string {
        return this._companyCodeSecuirtyService;
    };

    public static get getSapInfo(): object {
        return { ServiceLayerURL: this._apiUrlSap, CompanyDB: this._companyDb, GateWayApiURL: this._gateWayAPIUrl,DbInstance:this._dbInstance ,GateWayUserId:this._gatewayUserId,GateWayPassword:this._gatewayUserPassword};
    };

    public static get getApiUrl(): string {
      //  return environment._apiUrl;
      return environment._apiUrl;
    };

    public static get getSsoApiUrl(): string {
        return environment._ssoApiUrl;
    };

    public static get getTokenApiUrl(): string {
        return environment._tokenApiUrl;
    };

    public static get getTokenUser(): string {
        return environment._tokenUser;
    };

    public static get getTokenPwd(): string {
        return environment._tokenPwd;
    };

    public static get getTokenPrefix(): string {
        return environment._tokenPrefix;
    };

    public static get getRouteEForms(): string {
        return environment._routeEForms;
    };

    public static get getRouteVForms(): string {
        return environment._routeLVForms;
    };
}